// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"4452da68","234":"1f8b9276","453":"00d30409","455":"04775d9a","977":"f2b30480","988":"73201173"}[chunkId] + ".chunk.js";
};